export default "__VITE_ASSET__GFhXZJBE__"